import ApiEndpointConstants from "../constants/ApiEndpointConstants";
import api from "./API";

export const editComment = (nickname, logo, description, id, tieziid) => {
  return api.post(`${ApiEndpointConstants.EDIT_COMMENT}`, {
    nickname,
    logo,
    description,
    id,
    tieziid,
  });
};
export const addComment = (nickname, logo, description, tieziid) => {
  return api.post(`${ApiEndpointConstants.EDIT_COMMENT}`, {
    nickname,
    logo,
    description,
    tieziid,
  });
};
